var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mheader'),_c('div',{staticClass:"breadcrumb"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" / Article List ")],1),_c('article-list-item',{attrs:{"articleList":_vm.articleList}}),_c('mfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }